import { Routes, RouterModule, provideRoutes, ROUTER_CONFIGURATION } from '@angular/router';
import { InicioComponent } from './inicio/inicio.component';
import { ProductosComponent } from './Componentes/productos/productos.component';
import { CarritoDeComprasComponent } from './Componentes/carrito-de-compras/carrito-de-compras.component';
import { ContactoComponent } from './contacto/contacto.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { SearchSectionComponent } from './search-section/search-section.component';
import { ServicesComponent } from './services/services.component';
import { AppConstants } from './app.constants';

const Rutas: Routes = [
	//Inicio
	{ path: '', component: InicioComponent },

	//Productos
	{ path: "Productos", component: SearchSectionComponent },
	{ path: "Productos/:texto", component: SearchSectionComponent },
	{ path: `Productos/${AppConstants.mainCategoryPathRoute}/:mainCategoryId`, component: SearchSectionComponent },
	
	//Carrito de compras
	{ path: "CarritoDeCompras", component: CarritoDeComprasComponent },

	//About Us
	{ path: "Quienes-Somos", component: AboutUsComponent },

	//Downloads
	{ path: "Descargas", component: DownloadsComponent },

	// Services
	{ path: "Servicios", component: ServicesComponent },

	//Contact
	{ path: "Contacto", component: ContactoComponent },

	//Si no coinside ninguna
	{ path: '**', pathMatch: 'full', redirectTo: '' }
];

export const RUTEO = RouterModule.forRoot(Rutas, { useHash: true });